__turbopack_context__.v({
  "newsContainer": "TzvT5G_newsContainer",
  "newsHeading": "TzvT5G_newsHeading",
});
